"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMemoized = void 0;
const lodash_1 = require("lodash");
const react_1 = require("react");
function useMemoized(unstable) {
    const stable = react_1.useRef(unstable);
    if (stable.current !== unstable && !lodash_1.isEqual(stable.current, unstable)) {
        stable.current = unstable;
    }
    return stable.current;
}
exports.useMemoized = useMemoized;
//# sourceMappingURL=useMemoized.js.map